(() => {
  const FILTERS = ['application', 'voltage', 'power', 'technology', 'start'];
  const LABELS = {
    application: { dom: 'Do domu', budowa: 'Na budowę i w teren', warsztat: 'Do firmy i warsztatu', dzialka: 'Na działkę i wyjazd' },
    voltage: { '230': '230 V', '400': '400 V', dual: 'Dual Power' },
    power: { '1.8': '1,8 kW', '2.5': '2,5 kW', '2.8': '2,8 kW', '5': '5 kW', '6': '6 kW', '7': '7 kW' },
    technology: { avr: 'AVR', inverter: 'Inwerter' },
    start: { manual: 'Rozruch ręczny', electric: 'Rozruch elektryczny' }
  };
  const SEO_TITLES = {
    application: { dom: 'Agregaty mobilne do domu', budowa: 'Agregaty mobilne na budowę i w teren', warsztat: 'Agregaty mobilne do firmy i warsztatu', dzialka: 'Agregaty mobilne na działkę i wyjazd' },
    voltage: { '230': 'Agregaty jednofazowe 230 V', '400': 'Agregaty trójfazowe 400 V', dual: 'Agregaty Dual Power 230/400 V' },
    technology: { avr: 'Agregaty mobilne z AVR', inverter: 'Agregaty inwertorowe' },
    start: { manual: 'Agregaty z rozruchem ręcznym', electric: 'Agregaty z rozruchem elektrycznym' }
  };

  function injectStyles() {
    if (document.getElementById('kmc-mobile-hotfix')) return;
    const style = document.createElement('style');
    style.id = 'kmc-mobile-hotfix';
    style.textContent = `
      .kmc .kmc-filter-group[data-filter-group="stock"]{display:none!important}
      .kmc .kmc-filter-actions{order:-1;margin:0 0 4px;padding:0 0 15px;border-bottom:1px solid #e2e5e7;align-items:center}
      .kmc .kmc-filter-actions label{display:flex;align-items:center;gap:10px}
      .kmc .kmc-filter-actions select{height:40px;min-width:210px}
      .kmc .kmc-filter-actions>button[data-kmc-reset]{margin-left:auto;white-space:nowrap}
      .kmc .kmc-filter-compact-toggle{display:none;min-height:40px;border:1px solid #11151a;background:#11151a;color:#fff;padding:0 15px;font-weight:850;cursor:pointer;white-space:nowrap}
      .kmc .kmc-filter-compact-toggle span{margin-left:10px;font-size:18px;line-height:1}
      .kmc .kmc-filters.is-stuck{padding:10px 16px;box-shadow:0 12px 30px rgba(15,18,22,.12)}
      .kmc .kmc-filters.is-stuck .kmc-filter-actions{margin:0;padding:0;border:0}
      .kmc .kmc-filters.is-stuck .kmc-filter-compact-toggle{display:inline-flex;align-items:center}
      .kmc .kmc-filters.is-stuck .kmc-filter-group{display:none}
      .kmc .kmc-filters.is-stuck.is-expanded .kmc-filter-group:not([data-filter-group="stock"]){display:grid}
      .kmc .kmc-filters.is-stuck.is-expanded .kmc-filter-actions{margin-bottom:4px;padding-bottom:15px;border-bottom:1px solid #e2e5e7}
      .kmc .kmc-filters.is-stuck.is-expanded{max-height:calc(100vh - 16px);overflow:auto}
      .kmc .kmc-filter-toggle{display:none!important}
      @media(max-width:680px){
        .kmc .kmc-filters{display:block!important;position:sticky!important;top:0!important;z-index:20!important;padding:9px 10px!important;margin-bottom:14px!important;max-height:calc(100vh - 8px);overflow:auto}
        .kmc .kmc-filter-actions{display:grid!important;grid-template-columns:auto minmax(0,1fr) auto;gap:8px!important;margin:0!important;padding:0!important;border:0!important;align-items:center!important}
        .kmc .kmc-filter-compact-toggle{display:inline-flex;align-items:center;justify-content:center;min-height:42px;padding:0 13px}
        .kmc .kmc-filter-actions label{display:block!important;font-size:0!important;min-width:0}
        .kmc .kmc-filter-actions select{width:100%!important;min-width:0!important;height:42px!important;font-size:12px!important;padding-left:10px!important}
        .kmc .kmc-filter-actions>button[data-kmc-reset]{min-height:42px;margin:0!important;padding:0 8px!important;font-size:11px!important;text-decoration:none!important;border:1px solid #d5d9dc!important}
        .kmc .kmc-filter-group{display:none!important;padding:13px 0!important}
        .kmc .kmc-filters.is-expanded .kmc-filter-group:not([data-filter-group="stock"]){display:grid!important}
        .kmc .kmc-filters.is-expanded .kmc-filter-actions{padding-bottom:12px!important;border-bottom:1px solid #e2e5e7!important}
        .kmc .kmc-filter-group>div{display:flex!important;flex-wrap:nowrap!important;overflow-x:auto!important;scrollbar-width:none;padding-bottom:3px}
        .kmc .kmc-filter-group>div::-webkit-scrollbar{display:none}
        .kmc .kmc-card{border:0!important;border-radius:12px;overflow:hidden;box-shadow:0 7px 28px rgba(15,18,22,.09)}
        .kmc .kmc-card__media{aspect-ratio:1.18/1!important;background:linear-gradient(160deg,#fff 0%,#f4f5f5 100%)!important}
        .kmc .kmc-card__media img{padding:20px!important}
        .kmc .kmc-card__body{padding:20px!important}
        .kmc .kmc-card__head{align-items:center!important}
        .kmc .kmc-card__head h3{font-size:28px!important;letter-spacing:-.035em!important}
        .kmc .kmc-card__power strong{color:#e91c35!important;font-size:34px!important}
        .kmc .kmc-card__max{margin-top:17px!important;padding:11px 0!important}
        .kmc .kmc-card__chips{gap:7px!important;margin:16px 0!important}
        .kmc .kmc-card__chips span{padding:7px 9px!important;font-size:10px!important}
        .kmc .kmc-card__specs div{padding-block:12px!important}
        .kmc .kmc-card__specs dt{font-size:10px!important}
        .kmc .kmc-card__specs dd{font-size:13px!important}
        .kmc .kmc-card__footer{margin-top:18px!important;padding-top:17px!important;border-top:1px solid #e5e7e8}
        .kmc .kmc-card__price strong{font-size:23px!important}
        .kmc .kmc-card__footer .kmc-button{min-height:47px!important;padding-inline:18px!important}
        .kmc .kmc-card__compare{min-height:43px!important;margin-top:11px!important;border-radius:0!important}
      }
      @media(max-width:430px){
        .kmc .kmc-filter-actions{grid-template-columns:auto minmax(112px,1fr) auto}
        .kmc .kmc-filter-compact-toggle{padding:0 10px;font-size:11px}
        .kmc .kmc-filter-actions>button[data-kmc-reset]{font-size:0!important;width:42px;padding:0!important}
        .kmc .kmc-filter-actions>button[data-kmc-reset]::after{content:'×';font-size:22px;color:#e91c35}
      }
    `;
    document.head.appendChild(style);
  }

  const money = value => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: 'PLN', maximumFractionDigits: 0 }).format((Number(value) || 0) / 100);
  const comma = value => String(value ?? '').replace('.', ',');

  function init(root) {
    if (!root || root.dataset.kmcReady === 'true') return;
    root.dataset.kmcReady = 'true';
    injectStyles();

    const grid = root.querySelector('[data-kmc-grid]');
    const cards = [...root.querySelectorAll('[data-kmc-card]')];
    const countNodes = [...root.querySelectorAll('[data-kmc-count]')];
    const empty = root.querySelector('[data-kmc-empty]');
    const sort = root.querySelector('[data-kmc-sort]');
    const filters = root.querySelector('[data-kmc-filters]');
    const activeFilters = root.querySelector('[data-kmc-active-filters]');
    const featured = root.querySelector('[data-kmc-featured]');
    const heroTitle = root.querySelector('[data-kmc-hero-title]');
    const catalogKicker = root.querySelector('[data-kmc-catalog-kicker]');
    const catalogTitle = root.querySelector('[data-kmc-catalog-title]');
    const tray = root.querySelector('[data-kmc-tray]');
    const selectedCount = root.querySelector('[data-kmc-selected-count]');
    const selectedList = root.querySelector('[data-kmc-selected-list]');
    const openCompare = root.querySelector('[data-kmc-open-compare]');
    const clearCompare = root.querySelector('[data-kmc-clear-compare]');
    const dialog = root.querySelector('[data-kmc-dialog]');
    const compareBody = root.querySelector('[data-kmc-compare-body]');
    const closeCompare = root.querySelector('[data-kmc-close-compare]');
    const initialHeroTitle = heroTitle?.textContent || '';
    const initialKicker = catalogKicker?.textContent || '';
    const initialCatalogTitle = catalogTitle?.textContent || '';
    const state = { application: 'all', voltage: 'all', power: 'all', technology: 'all', start: 'all' };
    const selected = [];

    const stockGroup = filters?.querySelector('[data-filter-group="stock"]');
    stockGroup?.remove();
    const actions = filters?.querySelector('.kmc-filter-actions');
    if (actions && filters) {
      const clear = actions.querySelector('[data-kmc-reset]');
      if (clear) clear.textContent = 'Wyczyść';
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'kmc-filter-compact-toggle';
      toggle.setAttribute('aria-expanded', 'false');
      toggle.innerHTML = 'Filtry <span>+</span>';
      toggle.addEventListener('click', () => {
        const expanded = filters.classList.toggle('is-expanded');
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.querySelector('span').textContent = expanded ? '−' : '+';
      });
      actions.prepend(toggle);
      filters.prepend(actions);
    }

    const setButton = (group, value) => {
      const wrap = root.querySelector(`[data-filter-group="${group}"]`);
      if (!wrap) return false;
      const button = [...wrap.querySelectorAll('[data-filter-value]')].find(item => item.dataset.filterValue === value);
      if (!button) return false;
      wrap.querySelectorAll('[data-filter-value]').forEach(item => item.classList.toggle('is-active', item === button));
      return true;
    };

    const recommendationScore = card => 1e6 * ({ bestseller: 0, flagship: 1, compact: 2, standard: 3 }[card.dataset.merch] ?? 4) + 1e4 * Number(card.dataset.power) + Number(card.dataset.price);
    const sortCards = () => {
      if (!grid) return;
      const mode = sort?.value || 'recommended';
      const visible = cards.filter(card => !card.hidden);
      visible.sort((a, b) => {
        if (mode === 'power-asc') return Number(a.dataset.power) - Number(b.dataset.power) || Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'power-desc') return Number(b.dataset.power) - Number(a.dataset.power) || Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
        if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
        return recommendationScore(a) - recommendationScore(b);
      });
      visible.forEach(card => grid.appendChild(card));
    };

    const chosenFilters = () => Object.entries(state).filter(([, value]) => value !== 'all');
    const syncHeading = () => {
      const chosen = chosenFilters();
      if (featured) featured.hidden = chosen.length > 0;
      if (!chosen.length) {
        if (heroTitle) heroTitle.textContent = initialHeroTitle;
        if (catalogKicker) catalogKicker.textContent = initialKicker;
        if (catalogTitle) catalogTitle.textContent = initialCatalogTitle;
        return;
      }
      let title;
      if (chosen.length === 1) {
        const [group, value] = chosen[0];
        title = group === 'power' ? `Agregaty mobilne ${LABELS.power[value]}` : SEO_TITLES[group]?.[value] || `Agregaty mobilne — ${LABELS[group]?.[value] || value}`;
      } else {
        title = `Agregaty mobilne — ${chosen.map(([group, value]) => LABELS[group]?.[value] || value).join(' · ')}`;
      }
      if (heroTitle) heroTitle.textContent = title;
      if (catalogKicker) catalogKicker.textContent = 'Wybrana kategoria';
      if (catalogTitle) catalogTitle.textContent = title;
    };

    const syncUrl = () => {
      const params = new URLSearchParams(window.location.search);
      params.delete('view');
      FILTERS.forEach(key => state[key] === 'all' ? params.delete(key) : params.set(key, state[key]));
      params.delete('stock');
      history.replaceState(null, '', `${window.location.pathname}?${params.toString()}#modele`);
    };

    const apply = ({ sync = false } = {}) => {
      let total = 0;
      cards.forEach(card => {
        const applications = (card.dataset.application || '').split(',').map(item => item.trim()).filter(Boolean);
        const match = (state.application === 'all' || applications.includes(state.application)) &&
          (state.voltage === 'all' || card.dataset.voltage === state.voltage) &&
          (state.power === 'all' || Number(card.dataset.power) === Number(state.power)) &&
          (state.technology === 'all' || card.dataset.tech === state.technology) &&
          (state.start === 'all' || card.dataset.start === state.start);
        card.hidden = !match;
        if (match) total += 1;
      });
      countNodes.forEach(node => node.textContent = String(total));
      if (empty) empty.hidden = total !== 0;
      sortCards();
      const chosen = chosenFilters();
      if (activeFilters) {
        activeFilters.hidden = chosen.length === 0;
        activeFilters.innerHTML = chosen.map(([group, value]) => `<button type="button" data-remove-filter="${group}">${LABELS[group]?.[value] || value} ×</button>`).join('');
      }
      const compactToggle = filters?.querySelector('.kmc-filter-compact-toggle');
      if (compactToggle) compactToggle.firstChild.textContent = chosen.length ? `Filtry (${chosen.length}) ` : 'Filtry ';
      syncHeading();
      if (sync) syncUrl();
    };

    const reset = (sync = true) => {
      FILTERS.forEach(key => { state[key] = 'all'; setButton(key, 'all'); });
      if (sort) sort.value = 'recommended';
      apply({ sync });
    };

    const updateCompare = () => {
      cards.forEach(card => {
        const button = card.querySelector('[data-kmc-compare]');
        if (!button) return;
        const isSelected = selected.includes(card);
        button.setAttribute('aria-pressed', String(isSelected));
        button.innerHTML = isSelected ? '<span>✓</span> Wybrany do porównania' : '<span>+</span> Dodaj do porównania';
      });
      if (tray) tray.hidden = selected.length === 0;
      if (selectedCount) selectedCount.textContent = String(selected.length);
      if (selectedList) selectedList.innerHTML = selected.map(card => `<span>${card.dataset.model}</span>`).join('');
      if (openCompare) openCompare.disabled = selected.length < 2;
    };

    const toggleCompare = card => {
      const index = selected.indexOf(card);
      if (index >= 0) selected.splice(index, 1);
      else if (selected.length < 3) selected.push(card);
      else tray?.animate?.([{ transform: 'translateX(-50%)' }, { transform: 'translateX(calc(-50% - 8px))' }, { transform: 'translateX(calc(-50% + 8px))' }, { transform: 'translateX(-50%)' }], { duration: 260 });
      updateCompare();
    };

    const buildComparison = () => {
      if (!compareBody) return;
      const rows = [
        ['Moc nominalna', card => `<strong>${comma(card.dataset.power)} kW</strong>`],
        ['Moc maksymalna', card => `${comma(card.dataset.max)} kW`],
        ['Napięcie', card => card.dataset.voltageLabel],
        ['Technologia', card => card.dataset.techLabel],
        ['Rozruch', card => card.dataset.startLabel],
        ['Czas pracy', card => `${comma(card.dataset.runtime)} h`],
        ['Zbiornik', card => `${comma(card.dataset.tank)} l`],
        ['Zużycie paliwa', card => `${comma(card.dataset.consumption)} l/h`],
        ['Hałas', card => `${comma(card.dataset.noise)} dB`],
        ['Masa', card => `${comma(card.dataset.weight)} kg`],
        ['Dostępność', card => card.dataset.stock === 'in' ? 'Dostępny' : card.dataset.stock === 'confirm' ? 'Do potwierdzenia' : 'Niedostępny'],
        ['Cena', card => `<strong>${money(card.dataset.price)}</strong>`]
      ];
      compareBody.innerHTML = `<table class="kmc-compare-table"><thead><tr><th>Parametr</th>${selected.map(card => `<th>${card.dataset.image ? `<img src="${card.dataset.image}" alt="">` : ''}<div>${card.dataset.model}</div><a href="${card.dataset.url}">Zobacz model →</a></th>`).join('')}</tr></thead><tbody>${rows.map(([name, render]) => `<tr><td>${name}</td>${selected.map(card => `<td>${render(card)}</td>`).join('')}</tr>`).join('')}</tbody></table>`;
    };

    root.addEventListener('click', event => {
      const filter = event.target.closest('[data-filter-value]');
      if (filter) {
        const wrap = filter.closest('[data-filter-group]');
        const group = wrap?.dataset.filterGroup;
        if (!FILTERS.includes(group)) return;
        state[group] = filter.dataset.filterValue;
        wrap.querySelectorAll('[data-filter-value]').forEach(item => item.classList.toggle('is-active', item === filter));
        apply({ sync: true });
        return;
      }
      const remove = event.target.closest('[data-remove-filter]');
      if (remove) {
        state[remove.dataset.removeFilter] = 'all';
        setButton(remove.dataset.removeFilter, 'all');
        apply({ sync: true });
        return;
      }
      if (event.target.closest('[data-kmc-reset]')) { reset(); return; }
      const compare = event.target.closest('[data-kmc-compare]');
      if (compare) toggleCompare(compare.closest('[data-kmc-card]'));
    });

    sort?.addEventListener('change', sortCards);
    clearCompare?.addEventListener('click', () => { selected.splice(0); updateCompare(); });
    openCompare?.addEventListener('click', () => { buildComparison(); dialog?.showModal(); });
    closeCompare?.addEventListener('click', () => dialog?.close());
    dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });

    const params = new URLSearchParams(window.location.search);
    FILTERS.forEach(key => {
      const value = params.get(key);
      if (value && value !== 'all' && setButton(key, value)) state[key] = value;
    });
    params.delete('stock');

    if (filters) {
      const stickyStart = filters.getBoundingClientRect().top + window.scrollY;
      let ticking = false;
      const syncSticky = () => {
        const stuck = window.scrollY > stickyStart + 4;
        filters.classList.toggle('is-stuck', stuck);
        if (!stuck && window.innerWidth > 680) filters.classList.remove('is-expanded');
        ticking = false;
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { requestAnimationFrame(syncSticky); ticking = true; }
      }, { passive: true });
      syncSticky();
    }

    apply();
    updateCompare();
    if (chosenFilters().length || location.hash === '#modele') setTimeout(() => root.querySelector('#modele')?.scrollIntoView({ block: 'start' }), 80);
  }

  const boot = () => document.querySelectorAll('[data-kmc]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();